import { createEffect } from 'effector';

import { CreateEnterpriseSubscriptionRequestBody } from '@m/types/api';
import { EnterpriseSubscriptionService } from 'apps/admin/services';

export const getEntSubRedemptionCode = createEffect(
  EnterpriseSubscriptionService.getRedemptionCode,
);

// it looks like the secret is auto-generated. we can't provide it in the request body
export const createEntSubRedemptionCode = createEffect(
  ({ entId, subId }: { entId: number; subId: number }) =>
    EnterpriseSubscriptionService.createRedemptionCode({
      entId,
      subId,
    }).then((result) => {
      if (result && result.success) {
        getEntSubRedemptionCode({ entId, subId });
      }
      return result;
    }),
);

export const createEnterpriseSubscription = createEffect(
  ({
    enterpriseId,
    body,
  }: {
    body: CreateEnterpriseSubscriptionRequestBody;
    enterpriseId: number;
  }) =>
    EnterpriseSubscriptionService.create({
      enterpriseId,
      body,
    }).then((result) => {
      if (result && result.success) {
        // Since members/redemption-code are not returned in list response,
        // we need to fetch this data for each subscription.
        const { id: subId } = result.data.enterpriseSubscription;
        createEntSubRedemptionCode({ entId: enterpriseId, subId });
      }
      return result;
    }),
);

export const getEntSubMembers = createEffect(EnterpriseSubscriptionService.listMembers);

export const getEnterpriseSubscriptions = createEffect((entId: number) =>
  EnterpriseSubscriptionService.list({ entId }),
);

export const getEnterpriseSubscriptionDetail = createEffect(EnterpriseSubscriptionService.details);

export const updateEnterpriseSubscription = createEffect(EnterpriseSubscriptionService.update);

export const cancelEntSubscriptions = createEffect(EnterpriseSubscriptionService.cancel);

export const deleteEntSubMembers = createEffect(EnterpriseSubscriptionService.deleteMembers);

export const addUserToEntSub = createEffect(EnterpriseSubscriptionService.addMember);
